import { Text, ThemeIcon, Paper, Flex, Group } from "@mantine/core";
import { IconMail, IconPhone, IconClock } from "@tabler/icons-react";

export default function ContactCardsSection() {
  return (
    <Flex direction="column" align="center" py={60} px="xl" maw={1200} mx="auto" w="100%">
      <Flex gap="xl" wrap="wrap" w="100%">
        {/* Email Card */}
        <Paper p="xl" radius="lg" bg="white" withBorder flex={1} miw={300}>
          <Group gap="md" wrap="nowrap" align="flex-start">
            <ThemeIcon size={48} radius="xl" color="primary" variant="light">
              <IconMail size={24} />
            </ThemeIcon>
            <div>
              <Text fw={600} size="lg" mb={4}>
                Email
              </Text>
              <Text size="sm" c="primary.6" mb={4}>
                support@gtconnect.com
              </Text>
              <Text size="xs" c="slate.6">
                We'll respond within 24 hours
              </Text>
            </div>
          </Group>
        </Paper>

        {/* Phone Card */}
        <Paper p="xl" radius="lg" bg="white" withBorder flex={1} miw={300}>
          <Group gap="md" wrap="nowrap" align="flex-start">
            <ThemeIcon size={48} radius="xl" color="primary" variant="light">
              <IconPhone size={24} />
            </ThemeIcon>
            <div>
              <Text fw={600} size="lg" mb={4}>
                Phone
              </Text>
              <Text size="sm" c="primary.6" mb={4}>
                +1 (555) 123-4567
              </Text>
              <Text size="xs" c="slate.6">
                Mon-Fri, 9am-6pm EST
              </Text>
            </div>
          </Group>
        </Paper>

        {/* Business Hours Card */}
        <Paper p="xl" radius="lg" bg="white" withBorder flex={1} miw={300}>
          <Group gap="md" wrap="nowrap" align="flex-start">
            <ThemeIcon size={48} radius="xl" color="primary" variant="light">
              <IconClock size={24} />
            </ThemeIcon>
            <div>
              <Text fw={600} size="lg" mb={4}>
                Business Hours
              </Text>
              <Text size="sm" c="primary.6" mb={4}>
                Monday - Friday
              </Text>
              <Text size="xs" c="slate.6">
                9:00 AM - 6:00 PM EST
              </Text>
            </div>
          </Group>
        </Paper>
      </Flex>
    </Flex>
  );
}
